<div #closeBannerRef>
  @if (isVisible()) {
    <div (click)="closeBanner()" class="or-text-sm or-bg-shade-2">Zamknij reklamę</div>
  }
</div>
